export default __webpack_public_path__ + "static/media/portfolio4.491637f7.png";